import { VuexModule, Module, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import type { IPortfolioTree, ISetPortfolioTreeParams } from '@/types/IPortfolioTree';
import { updateDraft, savePortfolioTree } from '@/api-v2/web/portfolio-trees';
import { SaveChangesStore, SaveItemUniqueKey } from './SaveChangesStore';
import { useItemUnderAnalysisGlobalState } from '@/composables/useItemUnderAnalysis';

@Module({ dynamic: true, store, name: 'Portfolio', namespaced: true })
class Portfolio extends VuexModule {
  @Action({ rawError: true })
  public async UpdateDraft({
    slug,
    payload,
  }: {
    slug: string;
    payload: ISetPortfolioTreeParams;
  }): Promise<IPortfolioTree | null> {
    const { portfolioTreeUnderAnalysis } = useItemUnderAnalysisGlobalState();

    const tree = await updateDraft(slug, payload);
    portfolioTreeUnderAnalysis.value = tree;

    SaveChangesStore.RemoveItemsToSave([SaveItemUniqueKey.PORTFOLIO_TREE_DRAFT]);

    return tree;
  }

  @Action({ rawError: true })
  public async SavePortfolioTree({ slug }: { slug: string }): Promise<IPortfolioTree> {
    const tree = await savePortfolioTree(slug);
    SaveChangesStore.RemoveItemsToSave([SaveItemUniqueKey.PORTFOLIO_TREE_DRAFT, SaveItemUniqueKey.PORTFOLIO_TREE]);

    return tree;
  }
}

export const PortfolioModule = getModule(Portfolio);
